import React, { useState, useLayoutEffect } from 'react'
import SectionTitle from '../../components/section_title/section_title'
import Button from '../../components/Button/Button'
import Effectcontent from './EffectContent/Effectcontent'
import './showeffect.scss'

import white_number_a from '../../assets/white_number_a.png'
import white_number_b from '../../assets/white_number_b.png'
import white_number_c from '../../assets/white_number_c.png'


import gif01 from '../../assets/gif1.gif'
import gif02 from '../../assets/gif2.gif'
import gif03 from '../../assets/gif3.gif'

import icon_dot from '../../assets/icon_dot.png'

import gifRect from '../../assets/gifRect.gif'

const rotateMapping = new Map([
  [2, '53'],
  [3, '115'],
  [1, '-92']
])


const gifMapping = new Map([
  [2, gif02],
  [3, gif01],
  [1, gif03]
])
function ShowEffect() {
  const [currentRender, setCurrentRender] = useState(1)
  const [rotate, setRotate] = useState(rotateMapping.get(currentRender))

  useLayoutEffect(() => {
    setRotate(rotateMapping.get(currentRender))
  }, [currentRender])

  const pc_effect_content = <>  <div className="effect_container_01" onMouseEnter={() => { setCurrentRender(1) }}>
    <Effectcontent imguri={white_number_a} key="1" opacity={currentRender == 1} title="逼真材质表现" type="right">
      -<br />
      自然呈现绒毛、麂皮<br />
      金属等自然纹理<br />
      逼真如人眼所见
      </Effectcontent>
  </div>

    <div className="effect_container_02" onMouseEnter={() => { setCurrentRender(2) }}>
      <Effectcontent imguri={white_number_b} key="2" opacity={currentRender == 2} title="真实1:1复现" type="left">
        -<br />
      精准还原各类复杂精细结构<br />
      真实表现实物的每一处细节
      </Effectcontent>
    </div>

    <div className="effect_container_03" onMouseEnter={() => { setCurrentRender(3) }}>
      <Effectcontent imguri={white_number_c} key="3" opacity={currentRender == 3} title="人眼级自然观感" type="left">
        -<br />
      逼真呈现各类复杂层级结构，<br />
      自然环境光影让3D体验如同<br />
      观看实物
      </Effectcontent>
    </div></>

  return <div className="show_effect_container">
    <SectionTitle type="white">Hololux  光场复现建模优势及效果展示</SectionTitle>
    <div className="gif_screen">
      <img className="gif" src={gifMapping.get(currentRender)}></img>
      <div className="rotate_dot" style={{ transform: `rotate(${rotate}deg)` }}>
        <img src={icon_dot}></img>
      </div>
      {pc_effect_content}

    </div>

    <div className="mobile_gif_screen">
      <img className="mobile_gif" src={gifRect}></img>
      <div className="mobile_effect_content">
        <Effectcontent imguri={white_number_a} key="1" opacity={currentRender == 1} title="逼真材质表现" type="left">
          -<br />
            自然呈现绒毛、麂皮<br />
            金属等自然纹理<br />
            逼真如人眼所见
           </Effectcontent>
      </div>

      <div className="mobile_effect_content">
        <Effectcontent imguri={white_number_b} key="2" opacity={currentRender == 2} title="真实1:1复现" type="right">
          -<br />
        精准还原各类复杂精细结构<br />
        真实表现实物的每一处细节
      </Effectcontent>
      </div>

      <div className="mobile_effect_content">
        <Effectcontent imguri={white_number_c} key="3" opacity={currentRender == 3} title="人眼级自然观感" type="left">
          -<br />
        逼真呈现各类复杂层级结构，<br />
        自然环境光影让3D体验如同<br />
        观看实物
      </Effectcontent>
      </div>
    </div>

    <div className="effect_button_container">
      <Button><a href="#form">点击体验</a></Button>
      <p>点击体验更多品类光场模型逼真效果</p>
    </div>
  </div>
}

export default ShowEffect